import { render, staticRenderFns } from "./PreviewHome.vue?vue&type=template&id=63bc13bc"
import script from "./PreviewHome.vue?vue&type=script&lang=js"
export * from "./PreviewHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports